module.exports = __webpack_public_path__ + "img/left_img2_原_备份.c3e76144.png";